<template>
  <div class="od-page">
    <div class="od-body">
      <header class="od-top">
        <button type="button" class="od-back" aria-label="返回" @click="goBack">
          <img src="@/assets/images/svg/back.svg" alt="" />
        </button>
        <h1 class="od-title">订单详情</h1>
      </header>

      <div
        class="od-detail-layout"
        :class="{
          'od-detail-layout--with-logistics':
            logisticsTraceList && logisticsTraceList.length > 0,
        }"
      >
        <div class="od-detail-main">
          <section class="od-card">
            <h2 class="od-card__h">商品信息</h2>
            <div
              v-for="(x, index) in goodsList"
              :key="index"
              class="od-product-row"
            >
              <div class="od-product-row__main">
                <div class="od-product-thumb">
                  <img :src="x.goodsImage" alt="" />
                </div>
                <div class="od-product-meta">
                  <div class="od-product-name">{{ x.goodsName }}</div>
                  <div class="od-product-sub">数量：{{ x.quantity }}</div>
                </div>
              </div>
              <el-button
                class="od-btn od-btn--ghost"
                @click="jump('/myOrder/afterSale', x)"
              >
                申请售后
              </el-button>
            </div>
          </section>

          <section class="od-card">
            <h2 class="od-card__h">金额明细</h2>
            <div class="od-kv">
              <span class="od-kv__label">商品总价</span>
              <span class="od-kv__value">￥{{ formattedTotalAmount }}</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">订单运费</span>
              <span class="od-kv__value">￥{{ formattedLogisticsAmount }}</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">实付</span>
              <span class="od-kv__value">￥{{ formattedPayAmount }}</span>
            </div>
          </section>

          <section class="od-card">
            <h2 class="od-card__h">订单信息</h2>
            <div class="od-kv">
              <span class="od-kv__label">订单状态</span>
              <span class="od-kv__value">{{ orderStatusText }}</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">订单编号</span>
              <span class="od-kv__value">{{
                orderData.orderNo || orderData.id
              }}</span>
            </div>
            <div v-if="orderData.payOrderId" class="od-kv">
              <span class="od-kv__label">支付单号</span>
              <span class="od-kv__value">{{ orderData.payOrderId }}</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">收货人信息</span>
              <span class="od-kv__value">
                {{ orderData.receiverName }}
                {{ orderData.receiverPhone }}
                {{ orderData.receiverAddress }}
                {{ orderData.receiverDetailAddress }}
              </span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">交易快照</span>
              <span class="od-kv__value">发生争议时可作为判断依据</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">支付方式</span>
              <span class="od-kv__value">{{
                orderData.payChannelName || "待支付"
              }}</span>
            </div>
            <div class="od-kv">
              <span class="od-kv__label">创建时间</span>
              <span class="od-kv__value">{{ orderData.createTime }}</span>
            </div>
            <div v-if="orderData.payTime" class="od-kv">
              <span class="od-kv__label">付款时间</span>
              <span class="od-kv__value">{{ orderData.payTime }}</span>
            </div>
            <div v-if="orderData.completeTime" class="od-kv">
              <span class="od-kv__label">成交时间</span>
              <span class="od-kv__value">{{ orderData.completeTime }}</span>
            </div>
            <div v-if="orderData.shipTime" class="od-kv">
              <span class="od-kv__label">发货时间</span>
              <span class="od-kv__value">{{ orderData.shipTime }}</span>
            </div>
            <div v-if="orderData.logisticsNumber" class="od-kv">
              <span class="od-kv__label">快递单号</span>
              <span class="od-kv__value">{{ orderData.logisticsNumber }}</span>
            </div>
          </section>

          <div
            v-if="orderData.status === 'TO_BE_PAID'"
            class="od-actions od-actions--start"
          >
            <el-button class="od-btn od-btn--ghost" @click="cancelOfOrder">
              取消订单
            </el-button>
            <el-button
              v-if="hasRealChannel"
              type="danger"
              class="od-btn od-btn--danger"
              @click="payFor"
            >
              支付订单
            </el-button>
            <el-button
              v-if="hasMockChannel"
              class="od-btn od-btn--ghost od-mock-pay"
              @click="handleMockPay"
            >
              模拟支付（测试）
            </el-button>
          </div>
          <div v-else class="od-actions od-actions--start">
            <el-button
              v-if="orderData.status === 'SHIPPING'"
              type="warning"
              class="od-btn od-btn--warn"
              @click="receiveOfOrder"
            >
              确认收货
            </el-button>
            <template v-if="canApplyRefund">
              <el-button
                class="od-btn od-btn--primary"
                @click="openRefundDialog"
              >
                申请退款
              </el-button>
            </template>
            <template v-else-if="orderData.status === 'REFUNDING'">
              <span class="refund-tip">退款审核中，请等待商家处理</span>
            </template>
          </div>
        </div>

        <aside
          v-if="logisticsTraceList && logisticsTraceList.length > 0"
          class="od-card od-logistics"
        >
          <h2 class="od-card__h">物流轨迹</h2>
          <div
            v-for="(item, index) in logisticsTraceList"
            :key="index"
            class="od-logistics__item"
          >
            <div class="od-logistics__rail" aria-hidden="true"></div>
            <div class="od-logistics__text">
              <div class="od-logistics__time">{{ item.time }}</div>
              <div class="od-logistics__content">{{ item.content }}</div>
            </div>
          </div>
        </aside>
      </div>
    </div>

    <el-dialog
      v-model="refundDialogVisible"
      title="申请退款"
      width="460px"
      @close="refundForm.reason = ''"
    >
      <el-form label-width="80px">
        <el-form-item label="退款原因">
          <el-input
            v-model="refundForm.reason"
            type="textarea"
            maxlength="200"
            show-word-limit
            :rows="3"
            placeholder="请填写退款原因（选填）"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="refundSubmitting"
          @click="confirmRefund"
        >
          提交申请
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import {
  getOrderDetail,
  cancelOrder,
  receiveOrder,
  pay,
  applyRefund,
  mockPaymentSuccess,
  getPaymentChannels,
} from "@/api/shopping";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
const router = useRouter();
const orderData = ref({});
const goodsList = ref([]);
const logisticsTraceList = ref([]);
/** 当前已开启的支付方式（与后台支付管理同步） */
const enabledChannels = ref([]);

const statusMap = {
  TO_BE_PAID: "待付款",
  TO_BE_SHIPPED: "待发货",
  SHIPPING: "待收货",
  FINISHED: "已完成",
  CANCELED: "已取消",
  REFUNDING: "退款中",
  REFUNDED: "已退款",
};
const orderStatusText = computed(() =>
  orderData.value.status
    ? statusMap[orderData.value.status] || orderData.value.status
    : ""
);

const canApplyRefund = computed(() => {
  const s = orderData.value.status;
  return s === "TO_BE_SHIPPED" || s === "SHIPPING" || s === "FINISHED";
});

const refundDialogVisible = ref(false);
const refundSubmitting = ref(false);
const refundForm = ref({ reason: "" });

function formatMoney(val) {
  const n = Number(val);
  if (Number.isNaN(n)) return "0.00";
  return n.toFixed(2);
}
const formattedTotalAmount = computed(() =>
  formatMoney(orderData.value.totalAmount)
);
const formattedLogisticsAmount = computed(() =>
  formatMoney(orderData.value.logisticsAmount)
);
const formattedPayAmount = computed(() =>
  formatMoney(orderData.value.payAmount)
);

onMounted(() => {
  const route = useRoute();
  const id = route.params.id;
  fetchData(id);
  getPaymentChannels()
    .then((res) => {
      const list = res?.data ?? res;
      enabledChannels.value = Array.isArray(list) ? list : [];
    })
    .catch(() => {
      enabledChannels.value = [];
    });
});

const hasRealChannel = computed(() =>
  enabledChannels.value.some((c) => c.channelCode && c.channelCode !== "MOCK")
);
const hasMockChannel = computed(() =>
  enabledChannels.value.some((c) => c.channelCode === "MOCK")
);
const firstRealChannelCode = computed(() => {
  const ch = enabledChannels.value.find(
    (c) => c.channelCode && c.channelCode !== "MOCK"
  );
  return ch ? ch.channelCode : "ALI_PC";
});

const fetchData = (id) => {
  // 商品信息
  getOrderDetail({ id: id }).then((res) => {
    // console.log(res);
    if (res.code === 200) {
      orderData.value = res.data;
      goodsList.value = res.data.items || [];
      logisticsTraceList.value = res.data.logisticsTraceList;
      console.log(orderData.value);
    }
  });
};
const jump = (url, item) => {
  let data = {
    ...orderData.value,
  };
  if (item) {
    data.items = [item];
  }
  data = JSON.stringify(data);
  router.push({ path: url, query: { data: data } });
};

const goBack = () => {
  router.go(-1);
};

// 取消订单
const cancelOfOrder = () => {
  let id = orderData.value.id;
  cancelOrder({ id: id }).then((res) => {
    // console.log(res);
    if (res.code === 200) {
      fetchData(id);
      ElMessage({
        message: "取消成功",
        type: "success",
      });
    }
  });
};

// 去支付
const payFor = () => {
  pay({
    channelCode: firstRealChannelCode.value,
    id: orderData.value.id,
    returnUrl: window.location.origin || "http://web.ruixinai.cn:9006",
  }).then((res) => {
    if (res.code === 200) {
      window.open(res.data.displayContent, "_blank");
    }
  });
};

// 模拟支付（仅测试）
const handleMockPay = () => {
  const id = orderData.value.id;
  mockPaymentSuccess({ orderId: id })
    .then((res) => {
      if (res && res.code === 200) {
        fetchData(id);
        ElMessage.success("模拟支付成功，订单已变为待发货");
      } else {
        ElMessage.error(res?.message || "模拟支付失败");
      }
    })
    .catch((err) => {
      ElMessage.error(
        err?.response?.data?.message || err?.message || "模拟支付失败"
      );
    });
};

// 确认收货
const receiveOfOrder = () => {
  let id = orderData.value.id;
  receiveOrder({ id: id }).then((res) => {
    if (res.code === 200) {
      fetchData(id);
      ElMessage({ message: "收货成功", type: "success" });
    }
  });
};

const openRefundDialog = () => {
  refundForm.value.reason = "";
  refundDialogVisible.value = true;
};

const confirmRefund = () => {
  const id = orderData.value.id;
  const reason = refundForm.value.reason?.trim() || "用户申请退款";
  refundSubmitting.value = true;
  applyRefund({ id, refundReason: reason })
    .then((res) => {
      if (res.code === 200) {
        ElMessage.success("退款申请已提交，请等待商家处理");
        refundDialogVisible.value = false;
        fetchData(id);
      } else {
        ElMessage.error(res.message || "提交失败");
      }
    })
    .catch((err) => {
      ElMessage.error(
        err?.response?.data?.message || err?.message || "提交失败"
      );
    })
    .finally(() => {
      refundSubmitting.value = false;
    });
};

// const cancelAfterSale = () => {
//   ElMessageBox.confirm(
//     "proxy will permanently delete the file. Continue?",
//     "Warning",
//     {
//       confirmButtonText: "OK",
//       cancelButtonText: "Cancel",
//       type: "warning",
//     }
//   )
//     .then(() => {
//       let id = orderData.value.id;
//       cancelSale({ id: id }).then((res) => {
//         // console.log(res);
//         if (res.code === 200) {
//           fetchData(id);
//           ElMessage({
//             message: "取消成功",
//             type: "success",
//           });
//         }
//       });
//     })
//     .catch(() => {});
// };
// const handleType = (val) => {
//   avtiveType.value = val;
// };
</script>

<style scoped lang="scss">
@import "@/styles/order-flow.scss";

.od-detail-main {
  min-width: 0;
}

.od-btn--warn {
  min-width: 140px;
  height: 44px !important;
  font-size: 15px !important;
  font-weight: 600;
  border-radius: var(--ios-radius-md, 14px) !important;
}

.od-mock-pay {
  border-style: dashed !important;
  opacity: 0.92;
}
</style>
